import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import LoadingSpinner from './components/LoadingSpinner';
import Homepage from './pages/Homepage';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const { loading, isAuthenticated, isAdmin, isEmployee } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/" 
          element={isAuthenticated ? (
            isAdmin ? <Navigate to="/admin" replace /> : <Navigate to="/employee" replace />
          ) : (
            <Homepage />
          )} 
        />
        
        <Route 
          path="/login" 
          element={isAuthenticated ? (
            isAdmin ? <Navigate to="/admin" replace /> : <Navigate to="/employee" replace />
          ) : (
            <Login />
          )} 
        />

        {/* Protected Admin Routes */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Protected Employee Routes */}
        <Route
          path="/employee/*"
          element={
            <ProtectedRoute requireEmployee>
              <EmployeeDashboard />
            </ProtectedRoute>
          }
        />

        {/* Fallback route */}
        <Route 
          path="*" 
          element={<Navigate to="/" replace />} 
        />
      </Routes>
    </div>
  );
}

export default App;